import '@/compiled-icons/error-outline';
import '@/compiled-icons/info-outline';
import '@/compiled-icons/check-circle';
import '@/compiled-icons/alert';
import '@/compiled-icons/check';
import '@/compiled-icons/sync-rotated';
import '@/compiled-icons/refresh';
import '@/compiled-icons/minus';
import '@/compiled-icons/file-pdf-outline';
import '@/compiled-icons/package-down';
import '@/compiled-icons/chevron-right';
import '@/compiled-icons/chevron-left';
import '@/compiled-icons/excavator';
import '@/compiled-icons/file-multiple';
import '@/compiled-icons/checkbox-checked-outline';
import '@/compiled-icons/basket-plus';
import '@/compiled-icons/basket-outline';
import '@/compiled-icons/cash-multiple';
import '@/compiled-icons/save';
import '@/compiled-icons/truck';
import '@/compiled-icons/information';
import '@/compiled-icons/chevron-down';
import '@/compiled-icons/download';
import '@/compiled-icons/document-review';
import '@/compiled-icons/text-box-multiple-outline';
import '@/compiled-icons/folder-open';
import '@/compiled-icons/text-box-plus-outline';
import '@/compiled-icons/reset-lock';
import '@/compiled-icons/arrow-left-thick';
import '@/compiled-icons/file-document-edit';
import '@/compiled-icons/printer';
import '@/compiled-icons/link';
import '@/compiled-icons/show-more';
import '@/compiled-icons/check-box-outline';
import '@/compiled-icons/checkbox-blank-outline';
import '@/compiled-icons/email-send-outline';
import '@/compiled-icons/book-arrow-left-outline';
import '@/compiled-icons/accept-date';
import '@/compiled-icons/file-percent';
import '@/compiled-icons/archive-eye-outline';
import '@/compiled-icons/manufacturer-supplier-customer-hlk';
import '@/compiled-icons/month-mo';
import '@/compiled-icons/statistic-number-snr';
import '@/compiled-icons/trade-workshop-sale-hwv';
import '@/compiled-icons/calculator-variant-outline';
import '@/compiled-icons/article';
import '@/compiled-icons/article-group';
import '@/compiled-icons/branch';
import '@/compiled-icons/customer';
import '@/compiled-icons/department';
import '@/compiled-icons/main-business';
import '@/compiled-icons/delete-restore';
import '@/compiled-icons/position';
import '@/compiled-icons/warehouse';
import '@/compiled-icons/year-view';
import '@/compiled-icons/export';
import '@/compiled-icons/import';
import '@/compiled-icons/earth-arrow-right';
import '@/compiled-icons/delete';
import '@/compiled-icons/microsoft-excel';
import '@/compiled-icons/settings';
import '@/compiled-icons/text';
import '@/compiled-icons/magnify';
import '@/compiled-icons/upload-outline';
import '@/compiled-icons/add';
import '@/compiled-icons/email';
import '@/compiled-icons/arrow-decision';
import '@/compiled-icons/clear';
import '@/compiled-icons/clipboard-outline';
import '@/compiled-icons/calendar-range-outline';
import '@/compiled-icons/zoom-in';
import '@/compiled-icons/zoom-out';
import '@/compiled-icons/timer';
import '@/compiled-icons/funnel-outline';
import '@/compiled-icons/maps-outline';
import '@/compiled-icons/calendar-month';
import '@/compiled-icons/calendar-today';
import '@/compiled-icons/calendar-week';
import '@/compiled-icons/eye';
import '@/compiled-icons/bag';
import '@/compiled-icons/color-palette';
import '@/compiled-icons/note-plus-outline';
import '@/compiled-icons/account-arrow-left-outline';
import '@/compiled-icons/truck-fast-outline-int';
import '@/compiled-icons/truck-fast-outline-ext';
import '@/compiled-icons/factory-ext';
import '@/compiled-icons/factory-int';
import '@/compiled-icons/diff';
import '@/compiled-icons/trackunit';
import '@/compiled-icons/cog-outline';
import '@/compiled-icons/tag-text-outline';
import '@/compiled-icons/tools';
import '@/compiled-icons/format-list-checks';
import '@/compiled-icons/home';
import '@/compiled-icons/factory';
import '@/compiled-icons/account-badge-outline';
import '@/compiled-icons/account-badge';
import '@/compiled-icons/account';
import '@/compiled-icons/account-outline';
import '@/compiled-icons/individual-performance';
import '@/compiled-icons/pencil-outline';
import '@/compiled-icons/arrow-up';
import '@/compiled-icons/arrow-down';
import '@/compiled-icons/drag-horizontal-variant';
import '@/compiled-icons/phone';
import '@/compiled-icons/close-circle-outline';
import '@/compiled-icons/check-circle-outline';

export class IconsService {

    private static readonly ICON_MAP: Partial<Record<DisguiseDto.DisguiseIcon, string>> = {
        UPLOAD: 'upload-outline',
        REFRESH: 'refresh',
        SEARCH: 'magnify',
        CONFIRM: 'check-circle',
        SAVE: 'save',
        DIALOG: 'text',
        POSITIONTEXT: 'text',
        ARCHIVE: 'package-down',
        ARCHIVE_ALTERNATIVE: 'package-down',
        CUSTOMIZE: 'settings',
        EXPORTXLS: 'microsoft-excel',
        SHOW: 'information',
        SHOW_ALTERNATIVE: 'information',
        SHOW_OPTION: 'information',
        SHOW_SUBSTITUTE: 'information',
        COPY: 'file-multiple',
        COPYDIALOG: 'file-multiple',
        ADD: 'add',
        ADD_DIALOG: 'add',
        CONFIRMBUTTON: 'delete',
        DELETE: 'delete',
        DOCUMENT_REVIEW: 'document-review',
        LINK: 'link',
        EXPAND: 'chevron-down',
        MACHINEINFO: 'excavator',
        BOOKARROWLEFT: 'book-arrow-left-outline',
        DOWNLOAD: 'download',
        OPENORDER: 'text-box-multiple-outline',
        DOCUMENTHISTORY: 'folder-open',
        POSITIONDOCUMENT: 'folder-open',
        ADDEQUIPMENT: 'text-box-plus-outline',
        SELECT: 'arrow-left-thick',
        SELECT_AND_OPENDIALOG: 'arrow-left-thick',
        ADD_PURCHASEORDER: 'file-document-edit',
        ADD_TO_PRINTERSELECTION: 'printer',
        CHECKBOX: 'checkbox-blank-outline',
        PERCENT_DOCUMENT: 'file-percent',
        CHECKBOX_CHECKED: 'check-box-outline',
        ACCEPTDATE: 'accept-date',
        SHOW_MORE: 'show-more',
        SEND_EMAIL: 'email-send-outline',
        ARCHIVE_EYE: 'archive-eye-outline',
        STATISTIC_HLK: 'manufacturer-supplier-customer-hlk',
        STATISTIC_MONTH: 'month-mo',
        STATISTIC_SNR: 'statistic-number-snr',
        STATISTIC_HWV: 'trade-workshop-sale-hwv',
        STATISTIC_AR: 'article',
        STATISTIC_AG: 'article-group',
        STATISTIC_BR: 'branch',
        STATISTIC_KU: 'customer',
        STATISTIC_ABT: 'department',
        STATISTIC_HG: 'main-business',
        STATISTIC_ST: 'position',
        STATISTIC_LAG: 'warehouse',
        STATISTIC_JA: 'year-view',
        CALCULATOR_VARIANT: 'calculator-variant-outline',
        DELETE_RESTORE: 'delete-restore',
        EXPORT: 'export',
        IMPORT: 'import',
        EARTH_ARROW_RIGHT: 'earth-arrow-right',
        ERROR: 'error-outline',
        INFO: 'info-outline',
        SUCCESS: 'check-circle',
        WARNING: 'alert',
        MINUS: 'minus',
        CHECK: 'check',
        SYNC_ROTATED: 'sync-rotated',
        PDF: 'file-pdf-outline',
        CHEVRON_RIGHT: 'chevron-right',
        CHEVRON_LEFT: 'chevron-left',
        EXCAVATOR: 'excavator',
        CHECKBOX_CHECKED_OUTLINE: 'checkbox-checked-outline',
        BASKET: 'basket-outline',
        BASKET_PLUS: 'basket-plus',
        CASH: 'cash-multiple',
        PRINTER: 'printer',
        EMAIL: 'email',
        TRUCK: 'truck',
        MOVE: 'arrow-decision',
        RESET_LOCK: 'reset-lock',
        CLEAR: 'clear',
        CLIPBOARD: 'clipboard-outline',
        CALENDAR: 'calendar-range-outline',
        ZOOM_OUT: 'zoom-out',
        ZOOM_IN: 'zoom-in',
        TIMER: 'timer',
        FUNNEL: 'funnel-outline',
        MAPS: 'maps-outline',
        CALENDAR_MONTH: 'calendar-month',
        CALENDAR_DAY: 'calendar-today',
        CALENDAR_WEEK: 'calendar-week',
        EYE: 'eye',
        BAG: 'bag',
        COLOR_PALETTE: 'color-palette',
        ACCOUNT_ARROW_LEFT: 'account-arrow-left-outline',
        NOTE_PLUS: 'note-plus-outline',
        FACTORY_INT: 'factory-int',
        FACTORY_EXT: 'factory-ext',
        TRUCK_EXT: 'truck-fast-outline-ext',
        TRUCK_INT: 'truck-fast-outline-int',
        DIFF: 'diff',
        TRACKUNIT: 'trackunit',
        COG_OUTLINE: 'cog-outline',
        TAG_TEXT_OUTLINE: 'tag-text-outline',
        TOOLS: 'tools',
        FORMAT_LIST_CHECKS: 'format-list-checks',
        HOME: 'home',
        FACTORY: 'factory',
        ACCOUNT_OUTLINE: 'account-outline',
        ACCOUNT: 'account',
        ACCOUNT_BADGE: 'account-badge',
        ACCOUNT_BADGE_OUTLINE: 'account-badge-outline',
        INDIVIDUAL_PERFORMANCE: 'individual-performance',
        PENCIL_OUTLINE: 'pencil-outline',
        ARROW_UP: 'arrow-up',
        ARROW_DOWN: 'arrow-down',
        // horizontal bars, not drag-vertical-variant: in house they are the symbol for vertical
        // reordering (column dialog, document designer).
        DRAG_HANDLE: 'drag-horizontal-variant',
        CLOSE_CIRCLE_OUTLINE: 'close-circle-outline',
        CHECK_CIRCLE_OUTLINE: 'check-circle-outline'
    };

    getIcon(iconType: DisguiseDto.DisguiseIcon): string | undefined {
        return IconsService.ICON_MAP[iconType];
    }

    getCustomIconStyle(rowIcon: DisguiseDto.DTIconUrlRowDto, props: {
        isExpanded: boolean
    }) {
        let result: { [key: string]: string | string[] } = {};
        const isIconWithExpandConfiguration = rowIcon.actionConfiguration
            && rowIcon.actionConfiguration['@type'] === 'DTExpandSectionActionConfiguration';
        if (isIconWithExpandConfiguration && props.isExpanded) {
            // we found an icon with the expand action configuration. we will rotate the icon if the row is expanded
            result = {
                ...result,
                transform: 'rotate(180deg)'
            };
        }
        return result;
    }


}

const ICONS_SERVICE_INSTANCE = new IconsService();

export {ICONS_SERVICE_INSTANCE};
